<template>
    <modal name="static-modal-dialog" transition="pop-out" :width="modalWidth" height="auto" :scrollable="true"
           @before-open="beforeOpen" @opened="whenOpened">
        <loading :active.sync="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage"></loading>
        <div class="box">
            <div class="box-part">
                <div class="partition">
                    <div class="partition-title">{{title}}</div>
                    <youtubeVideo
                            v-for="data in videoContent"
                            v-bind:key="data.text"
                            :video-id="data.videoId"
                            :videoTitle="data.videoTitle"
                            :videoTimeTags="data.videoTimeTags"
                    />

                    <iframe-component v-for="data in iframeContent"
                                      v-bind:key="data.text" :src="data.iframeUrl"></iframe-component>

                    <div id="static-modal-content" class="form-content"></div>
                </div>
                <title-content-images-component v-for="data in titleContentImages" v-bind:key="data.text"
                                                :title="data.title" :description="data.description"
                                                :description2="data.description2"
                                                :image="data.image"></title-content-images-component>
<!--                <div class="d-flex align-items-center"></div>-->
                    <tag-component v-for="data in tagContent" v-bind:key="data.text"
                                   :href="data.url" :tagTitle="data.tagTitle"
                                   :description="data.descriptionTag"></tag-component>

            </div>
        </div>
    </modal>
</template>
<script>
    import titleContentImagesComponent from './subcomponents/TitleContentImagesComponent';
    import youtubeVideo from './subcomponents/YoutubeVideoComponent';
    import iframeComponent from './subcomponents/IFrameComponent';
    import tagComponent from './subcomponents/TagComponent';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    //import axios from 'axios';

    const MARGIN_FACTOR = 0.9;
    var contentItems = null;

    function enableComponentIfContainsTag(jsonArray, tag) {
        if (jsonArray !== undefined && jsonArray.length > 0 && tag in jsonArray[0])
            return jsonArray;

        return null;
    }

    export default {
        name: 'StaticModalDialog',
        // props: {
        //     name: String,
        // },
        components: {
            Loading,
            titleContentImagesComponent,
            youtubeVideo,
            iframeComponent,
            tagComponent
        },
        data() {
            return {
                items: [{
                    modalWidth: window.innerWidth * MARGIN_FACTOR,
                    modalHeight: window.innerHeight * MARGIN_FACTOR,
                    titleHeight: window.innerHeight * (1 - MARGIN_FACTOR)
                }],
                isLoading: true,
                fullPage: false,
                title: '...',
                src: "#",
                backgroundColor: "white",
                videoContent: null,
                titleContentImages: null,
                tagContent: null,
                iframeContent: null
            }
        },
        created() {
            this.modalWidth = window.innerWidth * MARGIN_FACTOR;
            this.modalHeight = window.innerHeight * MARGIN_FACTOR;
            this.titleHeight = window.innerHeight * (1 - MARGIN_FACTOR);
        },
        methods: {
            beforeOpen(event) {
                try {
                    this.title = event.params.title;
                    this.name = event.params.name;
                    contentItems = event.params.items;
                    this.titleContentImages = enableComponentIfContainsTag(contentItems, 'title') || enableComponentIfContainsTag(contentItems, 'description');
                    this.videoContent = enableComponentIfContainsTag(contentItems, 'videoTitle');
                    this.iframeContent = enableComponentIfContainsTag(contentItems, 'accountContainer');
                    this.tagContent = enableComponentIfContainsTag(contentItems, 'tagTitle');

                    /*
                    axios.get('https://github.com/DejanL/SRIP-WSO2',{headers: {
                            'Content-Type': 'application/json'
                        }})
                        .then(function (response) {
                            console.log(response.data);
                            console.log(response.status);
                            console.log(response.statusText);
                            console.log(response.headers);
                            console.log(response.config);
                        }, function (error) {
                            // Do something with request error
                            console.log(error);
                        });
                    */

                } catch (err) {
                    console.log(err);
                }
            },
            whenOpened() {
                this.isLoading = false;
            },
            onCancel() {
                this.isLoading = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    $background_color: #404142;
    $github_color: #DBA226;
    $facebook_color: #3880FF;

    div.github:before {
        content: "\f095";
        /*font-family: FontAwesome;*/
    }


    .form-content {
        height: inherit;
        width: inherit;
        padding-left: 10px;
        padding-top: 10px;
    }

    .box {
        background: white;
        overflow: hidden;
        width: 656px;
        height: 400px;
        border-radius: 2px;
        box-sizing: border-box;
        box-shadow: 0 0 40px black;
        color: #393a3b;
        font-size: 0;
        background: url("../../assets/pic/iot-header.png") repeat-x left bottom;
        background-size: 400px 153px;

        .box-part {
            display: inline-block;
            position: relative;
            vertical-align: top;
            box-sizing: border-box;
            height: 100%;
            width: 100%;
            padding: 10px;

            /*&#bp-right {*/

            /*    border-left: 1px solid #eee;*/
            /*}*/
        }

        .box-messages {
            position: absolute;
            /*left: 0;*/
            bottom: 0;
            width: 100%;
        }

        .box-error-message {
            position: relative;
            overflow: hidden;
            box-sizing: border-box;

            height: 0;
            line-height: 32px;
            padding: 0 12px;
            text-align: center;
            width: 100%;
            font-size: 11px;
            color: white;
            background: #F38181;
        }

        .partition {
            width: 100%;
            height: 100%;

            .partition-title {
                box-sizing: border-box;
                padding: 5px;
                width: 100%;
                text-align: center;
                letter-spacing: 1px;
                font-size: 28px;
                font-weight: 300;
            }

            .partition-form {
                padding: 0 20px;
                box-sizing: border-box;
            }
        }

        /*input[type=password],*/
        input {
            display: block;
            margin-bottom: 4px;
            width: 100%;
            font-size: 12px;
            padding: 4px 8px;
            font-family: inherit;
            transition: 0.5s all;
            outline: none;
        }

        button {
            background: white;
            border-radius: 4px;
            box-sizing: border-box;
            padding: 10px;
            letter-spacing: 1px;
            font-family: "Open Sans", sans-serif;
            font-weight: 400;
            min-width: 140px;
            margin-top: 8px;
            color: #8b8c8d;
            cursor: pointer;
            border: 1px solid #DDDEDF;
            text-transform: uppercase;
            transition: 0.1s all;
            font-size: 10px;
            outline: none;

            &:hover {
                border-color: mix(#DDDEDF, black, 90%);
                color: mix(#8b8c8d, black, 80%);
            }
        }

        .large-btn {
            width: 100%;
            background: white;

            span {
                font-weight: 600;
            }

            &:hover {
                color: white !important;
            }
        }

        .button-set {
            margin-bottom: 8px;
            margin-top: 100px;
        }

        #register-btn,
        #signin-btn {
            margin-left: 8px;
        }

        .facebook-btn {
            border-color: $facebook_color;
            color: $facebook_color;

            &:hover {
                border-color: $facebook_color;
                background: $facebook_color;
            }
        }

        .github-btn {
            border-color: $github_color;
            color: $github_color;

            &:hover {
                border-color: $github_color;
                background: $github_color;
            }
        }

        .autocomplete-fix {
            position: absolute;
            visibility: hidden;
            overflow: hidden;
            opacity: 0;
            width: 0;
            height: 0;
            /*left: 0;*/
            top: 0;
        }
    }

    .pop-out-enter-active,
    .pop-out-leave-active {
        transition: all 0.5s;
    }

    .pop-out-enter,
    .pop-out-leave-active {
        opacity: 0;
        transform: translateY(24px);
    }
</style>
